"use client";

import { RainbowKitProvider as RainbowKitProviderComponent } from "@rainbow-me/rainbowkit";
import "@rainbow-me/rainbowkit/styles.css";

import { rainbowKitInitialProps } from "@/lib/integrations/rainbow-kit";

import { useVirtualMachineContext } from "@/subsystems/exchange/virtual-machine-provider";

function RainbowKitProvider({ children }: React.PropsWithChildren) {
  const { ethereumVirtualMachineChainId } = useVirtualMachineContext();

  const initialProps = {
    ...rainbowKitInitialProps,
    initialChain: ethereumVirtualMachineChainId,
  };

  return <RainbowKitProviderComponent {...initialProps}>{children}</RainbowKitProviderComponent>;
}

export default RainbowKitProvider;
